import React from 'react';
import { Grid } from '@mui/material';
import PageHeader from '../../../components/page-header';
import { GridPanel } from '../../../components/list-grid-panel';
import UnidEntityDataTable from './components/unid-entity-data-table';
import { UnidEntityDrawer } from './components/unid-entity-drawer';
import { useUnidEntitySearchController } from './context/unid-entity-search-controller';
import { useUnidEntitySearchState } from './context/unid-entity-search-context';

export function UnidEntitySearchComponent() {
    const ctrl = useUnidEntitySearchController();
    const { searchTrigger, drawerOpen } = useUnidEntitySearchState();

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Unidades"
                    subtitle="Unidades da entidade usadas em compras, IRPs e contratos"
                    breadcrumbs={[{ label: 'Unidades' }]}
                />
            </Grid>

            <Grid item xs={12}>
                <GridPanel addLabel="Nova unidade" onAdd={ctrl.openDrawer}>
                    <UnidEntityDataTable searchTrigger={searchTrigger} />
                </GridPanel>
            </Grid>

            <UnidEntityDrawer open={drawerOpen} isSaving={ctrl.isSaving} onClose={ctrl.closeDrawer} onSave={ctrl.handleSave} />
        </React.Fragment>
    );
}
